import React from "react";

import { Check } from "icons";
import * as yup from "yup";

import { Steward } from "components/Common/TableStyle";
import { ColumnStyle } from "components/Common/TableStyle";

export const ASSOCIATE_BUSINESS_TERM_COLUMN = [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
    width: "30%",
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: "60%",
  },
  {
    title: "",
    key: "checked",
    dataIndex: "checked",
    render: text =>
      text && <Check size={15} style={{ color: "rgb(34, 118, 251)" }} />,
    width: "10%",
  },
];

export const DOMAIN_BUSINESS_TERM_COLUMN = [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
    width: "30%",
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: "60%",
  },
  {
    title: "# Domain",
    key: "domains_count",
    dataIndex: "domains_count",
    width: "30%",
    render: text => <ColumnStyle text={text} />,
  },
  {
    dataIndex: "drafter",
    key: "drafter",
    title: "Drafter",
    width: "45%",
    render: row => <Steward name={row?.name} title={row?.role} />,
  },
  {
    dataIndex: "approver",
    key: "approver",
    title: "Approver",
    width: "45%",
    render: row => <Steward name={row?.name} title={row?.role} />,
  },
];

export const BUSINESS_TERM_VALIDATION_SCHEMA = yup.object({
  name: yup.string().trim().required("Name is required"),
  drafter: yup.object().required("Drafter is required"),
  approver: yup.object().required("Approver is required"),
  variations: yup.array().of(
    yup.object().shape({
      name: yup.string().trim().required("Variation name is required"),
      description: yup.string(),
    })
  ),
});

export const INITIAL_BUSINESS_TERM_VALUES = {
  name: "",
  description: "",
  approver: "",
  drafter: "",
  variations: [],
};
